// Drawer width constants
export const drawerWidth = 310;
export const drawerWidthMD = 270;
export const drawerWidthCollapsed = 72;
